import React from 'react';
import { FaClock } from 'react-icons/fa';

const InactivityTimer = ({ timeLeft, formatTime, isActive }) => {
  if (!timeLeft || !isActive) return null;

  const getTimerColor = () => {
    if (timeLeft <= 30000) return 'text-red-200'; // Last 30 seconds - red
    if (timeLeft <= 60000) return 'text-orange-200'; // Last minute - orange
    return 'text-blue-200'; // Normal - blue
  };

  const getBackgroundColor = () => {
    if (timeLeft <= 30000) return 'bg-red-900/20 border-red-300/30'; // Last 30 seconds
    if (timeLeft <= 60000) return 'bg-orange-900/20 border-orange-300/30'; // Last minute
    return 'bg-blue-900/20 border-blue-300/30'; // Normal
  };

  return (
    <div className={`flex items-center space-x-1 px-2 py-1 rounded-md border ${getBackgroundColor()} shadow-sm transition-all duration-300 ease-in-out`}>
      <FaClock className={`text-xs ${getTimerColor()} transition-colors duration-300`} />
      <span className={`text-xs font-medium ${getTimerColor()} transition-colors duration-300`}>
        {formatTime(timeLeft)}
      </span>
    </div>
  );
};

export default InactivityTimer;
